export default "__VITE_ASSET__DZqkyLC3__"